<template>
    <v-container>
        <v-card outlined>
        <v-card-subtitle class="pb-0">
            <v-row><v-col> วันที่ใบแจ้งหนี้ </v-col> </v-row>
            <v-row>
                <v-col cols="2"><DatePicker label="ตั้งแต่วันที่" @dateFormatted="setDateFrom" ></DatePicker></v-col>
                <v-col cols="2"><DatePicker label="ถึงวันที่" @dateFormatted="setDateTo" ></DatePicker></v-col>
                <v-spacer></v-spacer>
                <v-col class="text-right">
                     <v-row>
                        <v-btn  class="ma-2" color="primary" @click="search" small><v-icon>search</v-icon> ค้นหา</v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-subtitle>
    </v-card>
    <v-spacer></v-spacer>
     {{selected_count}}
    <!-- <v-btn  class="ma-2" color="red darken-1 bold" small @click="withdrawClick">ตั้งเบิก</v-btn> -->
        <v-btn class="ma-2" color="red" dark @click="withdrawClick" small>ตั้งเบิก
        <v-icon dark right >gavel</v-icon>
      </v-btn>
    <!-- <template v-slot:center> -->
                <v-dialog v-model="confirmDialog" width="500">
                    <DialogWithdraw :withdrawData="withdrawData" @closeDialog="close" width="500"></DialogWithdraw> 
                </v-dialog>
                    
    <!-- </template> -->
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            item-key="invoiceNo"
            show-select
            class="elevation-1"
            >
        </v-data-table>
    </v-container>
</template>

<script>
import DatePicker from '@/components/Shared/DatePicker'
import {listInvoice,insertWithdraw} from '@/api/accounting/withdraw-api.js'
import DialogWithdraw from './DialogWithdraw'
import numeral from 'numeral'
export default {
    name: 'View1',
    components: {
        DatePicker,
        DialogWithdraw
    },
    computed: {
       selected_count() {
        return this.selected.length + " รายการ / "+ this.items.length +" รายการ";
      }
    },
    props: ["branchCode"],
    data: () => ({
        confirmDialog: false,
        selected: [],
        headers: [
            {text: "วันที่ใบแจ้งหนี้", value: "strInvoiceDate"},
            {text: "ทะเบียน", value: "licenseNo"},
            {text: "เลขที่ใบสั่งซ่อม", value: "jobNo"},
            {text: "เลขที่ใบประเมิน", value: "estimateNo"},
            {text: "เลขที่ใบแจ้งหนี้", value: "invoiceNo"},
            {text: "ยอด", value: "invoiceAmountDisplay"},
           // {text: "หมายเหตุ", value: "remark"}
        ],
        items: [],
        dateFrom: null,
        dateTo: null,
        withdrawData:[]
    }),
    methods: {
        setDateFrom(val) {
            this.dateFrom = val;
        },
        setDateTo(val) {
            this.dateTo = val;
        },
        withdrawClick() {
            var sumTotal = 0;
            var sumGrandTotal = 0;
            
            this.selected.forEach(element => {
                sumTotal += element.serviceTotal;
                sumGrandTotal += element.trnGrandTotal;
            });
            
            if(this.selected.length == 0) {
            alert('please select item!!'); 
            return;
            }

            var result = confirm("ต้องการยืนยันการตั้งเบิกใช่หรือไม่?");
            if(!result){ return; }

            // call api withdraw     
            this.withdrawData.rankDate = this.dateFrom +"-"+this.dateTo;
            this.withdrawData.trnCount = this.selected.length;
            this.withdrawData.trnTotal = sumTotal;
            this.withdrawData.trnGrandTotal = sumGrandTotal;
            this.withdrawData.branchCode = this.branchCode;
            this.withdrawData.listData = this.selected;

            insertWithdraw(this.withdrawData).then(response => {
                this.$loading(false);

                if (response) {
                    if(response.withdrawId == 0) { 
                        alert("บางรายการมีการตั้งเบิกไปแล้ว กรุณาทำรายการใหม่!!!"); 
                        this.search();
                    }else{
                        response.trnTotalDisplay = numeral(response.trnTotal).format('0,0.00');
                        response.trnGrandTotalDisplay = numeral(response.trnGrandTotal).format('0,0.00');
                        this.withdrawData = response;
                        this.confirmDialog = true;
                    }
                    
                }
                
            }).catch(()=> {
                this.$loading(false);
            });    

            //this.confirmDialog = true;
        },
        listItem() {
            this.$loading(true);
            listInvoice(this.dateFrom,this.dateTo,this.branchCode).then(response => {
                this.$loading(false);
                this.items = response;
                if (this.items) {
                this.items.forEach((e) => {
                    e.invoiceAmountDisplay = numeral(e.invoiceAmount).format('0,0.00');
                    
                });
            }
            }).catch(()=> {
                this.$loading(false);
            });
        },
        search(){
            this.listItem();
            this.selected = [];
        },
        close() {
            this.confirmDialog = false;
            this.search();
        }
    }
}
</script>